module.exports = __webpack_public_path__ + "static/media/seja-franqueado.51a4b8a0.png";